// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3qI4Z","active":"styles-module--active--2g_3B","section":"styles-module--section--R9D3U","year":"styles-module--year--dBC5N"};